// Pilula de status Ativo/Inativo pras listas. Daltonismo-safe: nao depende de
// verde/vermelho — Ativo usa um tom suave da cor da marca (--primary) com um
// ponto, Inativo fica cinza apagado. Calmo de proposito (aparece em toda
// linha), sem virar "muro de cor". Estilos em styles.css (.status-pill*).
interface Props {
  ativo: boolean;
  /** rotulos custom (default Ativo/Inativo) */
  labelAtivo?: string;
  labelInativo?: string;
}

export function StatusBadge({ ativo, labelAtivo = 'Ativo', labelInativo = 'Inativo' }: Props) {
  return (
    <span data-componente="003" className={`status-pill ${ativo ? 'status-pill-ativo' : 'status-pill-inativo'}`}>
      <span className="status-pill-dot" />
      {ativo ? labelAtivo : labelInativo}
    </span>
  );
}
